import React from 'react';

export default function LoadingDots() {
  return (
    <div className="loading-dots-wrapper">
      <span className="loading-dot" />
      <span className="loading-dot" />
      <span className="loading-dot" />
    </div>
  );
}
